module.exports = __webpack_public_path__ + "img/ieit_systems.0d740880.svg";